module.exports = __webpack_public_path__ + "img/programs2.66a0394c.svg";